import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import axios from 'axios'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeMathjax from 'rehype-mathjax'
import { useNavigate } from 'react-router-dom'
import {
  Form,
  Container,
  Segment,
  List,
  Loader,
  Menu,
  Checkbox,
  Image,
} from 'semantic-ui-react'
import { TextAuto, MarkdownHighlighter } from './components'
import { validateEmail } from './validation'
import conf from './conf'

const Chat = () => {
  const navigate = useNavigate()
  const [ name, setName ] = useState(conf.user.name)
  const [ email, setEmail ] = useState(conf.user.email)
  const [ prompt, setPrompt ] = useState('')
  const [ nameError, setNameError ] = useState('')
  const [ emailError, setEmailError ] = useState('')
  const [ promptError, setPromptError ] = useState('')
  const [ messages, setMessages ] = useState([])
  const [ loading, setLoading ] = useState(false)
  const [ markdown, setMarkdown ] = useState(true)
  const [ advanced, setAdvanced ] = useState(false)

  const handleSubmit = async () => {
    if (isEmpty(name)) {
      return setNameError('Please enter a valid name')
    } else {
      setNameError('')
    }
    if (!validateEmail(email)) {
      return setEmailError('Please enter a valid email address')
    } else {
      setEmailError('')
    }
    if (isEmpty(prompt)) {
      return setPromptError('Please enter a text')
    } else {
      setPromptError('')
    }

    messages.unshift({
      text: prompt,
      response: false
    })
    setMessages(messages)
    setLoading(true)
    setPrompt('')

    try {
      const response = await axios.get(`${conf.api.url}/ask`, {
        params: { prompt, advanced, name, email },
      })
      console.log('response:', response);
      messages.unshift({
        text: response.data,
        response: true,
      })
      setMessages(messages)
      setLoading(false)
    } catch (error) {
      console.error('error:', error);
    }
  }

  return (
    <Container>
      <Menu size='tiny'>
        <Menu.Item header onClick={() => navigate('/')}>
          <Image avatar alt="logo" src='/images/catTTY.png' />
           Quantum GPT
        </Menu.Item>
        <Menu.Item onClick={() => navigate('/chat')} active>
          Chat
        </Menu.Item>
        <Menu.Item position='right' onClick={() => navigate('/')}>
          Exit
        </Menu.Item>
      </Menu>

      <Segment secondary>
        <Form onSubmit={handleSubmit}>
          <Form.Group inline>
            <Form.Input
              placeholder='Name'
              name='name'
              value={name}
              onChange={e => setName(e.target.value)}
              error={ !isEmpty(nameError) && {
                content: nameError,
                pointing: 'above',
              }}
              width={6}
              required
            />
            <Form.Input
              placeholder='Email'
              name='email'
              value={email}
              onChange={e => setEmail(e.target.value)}
              error={ !isEmpty(emailError) && {
                content: emailError,
                pointing: 'above',
              }}
              width={6}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Field
              control={TextAuto}
              placeholder="Send a message"
              onChange={e => setPrompt(e.target.value )}
              useCacheForDOMMeasurements
              value={prompt}
              error={ !isEmpty(promptError) && {
                content: promptError,
                pointing: 'above',
              }}
              required
              width={16}
            />
          </Form.Group>
          <Form.Group inline>
            <Form.Field>
              <Checkbox
                label='Markdown'
                checked={markdown}
                onChange={(e, data) => setMarkdown(data.checked)}
              />
            </Form.Field>
            <Form.Field>
              <Checkbox
                label='Advanced mode'
                checked={advanced}
                onChange={(e, data) => setAdvanced(data.checked)}
              />
            </Form.Field>
            <Form.Button
              icon='send'
              content='Send'
              width={4}
            />
          </Form.Group>
        </Form>
      </Segment>

      <Loader active={loading} inline='centered' />
      <List divided selection>
        {messages.map(({ text, response }, index) => (
          <List.Item key={index}>
            <List.Icon name={ response ? 'server' : 'user' } size='big'>
              {/* A trick to show image properly is to wrap it with icon */}
              {/*
              <Image avatar style={{width: '30px', height: '30px', marginTop: '-60px' }} src={ response ? '/qcopilot-avatar.png' : '/user-avatar.png' } />
              */}
            </List.Icon>
            <List.Content>
              <List.Header as='a'>{ response ? 'Quantum GPT' : `${name}` || '<USER>' }
              </List.Header>
              <List.Description>
                { markdown
                  ? <ReactMarkdown
                      children={text}
                      remarkPlugins={[remarkGfm, remarkMath]}
                      rehypePlugins={[rehypeMathjax]}
                      components={MarkdownHighlighter}
                    />
                  : text
                }
              </List.Description>
            </List.Content>
          </List.Item>
        ))}
      </List>

    </Container>
  )
}

export default Chat
